import Api from '../helpers/api';

export function fetchJobTitlesData() {
  return Api.get('/preset/fields-of-work');
}
